import styled, { css } from 'styled-components';
import { mixins, media } from '@pik/pik-ui';

const S = {};

S.Wrapper = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
`;

S.VideoPlayerWrapper = styled.div`
  max-width: calc(100% - 310px);
  max-height: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  opacity: 0;
  
  ${({ canPlay }) => canPlay && css`
    opacity: 1;
  `}
  
  > div {
    height: 100%;
    width: 100%;
    
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%; 
    }
  }
  
  video {
    width: 100%;
    
    source {
      width: 100%;
    }
  }
  
  ${({ isYouTube }) => isYouTube && css`
    width: 101vw;
    height: 60vh;
    opacity: 1;
  `}
  
  @media ${media.max1280} {
    max-width: 100%;
    max-height: 100%;
  }
`;

export default S;
